export const NAVGRID_INCOMPLETE_ROUTE_STATE = "partial_network_gap";

const toPoint = (value) => {
  const lat = Number(value?.lat);
  const lon = Number(value?.lon ?? value?.lng);
  return Number.isFinite(lat) && Number.isFinite(lon) ? { lat, lon } : null;
};

const distanceMeters = (a, b) => {
  const from = toPoint(a);
  const to = toPoint(b);
  if (!from || !to) return 0;
  const radians = (degrees) => (degrees * Math.PI) / 180;
  const dLat = radians(to.lat - from.lat);
  const dLon = radians(to.lon - from.lon);
  const lat1 = radians(from.lat);
  const lat2 = radians(to.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) ** 2;
  return 6371000 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
};

export function hasRelevantNavGridExternalConnector(externalSegments, minMeters = 15) {
  const minimum = Math.max(0, Number(minMeters) || 0);
  return (Array.isArray(externalSegments) ? externalSegments : []).some((segment) => {
    const points = (Array.isArray(segment) ? segment : []).map(toPoint).filter(Boolean);
    if (points.length < 2) return false;
    let total = 0;
    for (let index = 1; index < points.length; index += 1) {
      total += distanceMeters(points[index - 1], points[index]);
    }
    return total >= minimum;
  });
}

export function getNavGridIncompleteRouteMessage(language = "pt") {
  return String(language || "pt").toLowerCase().startsWith("en")
    ? "The navigation network does not yet reach this location. Follow the available route carefully; we are working on extending the network."
    : "A rede de navegação ainda não chega a este local. Segue com atenção o percurso disponível; estamos a trabalhar para ampliar a rede.";
}
